export const CENTER_FULL_SERVICE_UNAVAILABLE_MESSAGE =
    '운영 관리를 위해 자정부터 오전 5시까지 서비스를 이용할 수 없습니다. 오전 5시 이후 다시 이용해주세요.';

export const CENTER_RESERVATION_TIME_RESTRICTED_MESSAGE =
    '현재는 예약 가능 시간이 아닙니다. 다음날 오전 5시 이후 다시 이용해주세요.';

export const CENTER_RESERVATION_AVAILABLE_TIME_LABEL = '매일 오전 5시 ~ 오후 1시';

export const CENTER_SERVICE_AVAILABILITY_STATUS = {
    FULL_CENTER_BLOCKED: 'FULL_CENTER_BLOCKED',
    SERVICE_RESERVATION_BLOCKED: 'SERVICE_RESERVATION_BLOCKED',
    AVAILABLE: 'AVAILABLE',
} as const;

export type CenterServiceAvailabilityStatus =
    (typeof CENTER_SERVICE_AVAILABILITY_STATUS)[keyof typeof CENTER_SERVICE_AVAILABILITY_STATUS];

export function getCenterServiceAvailabilityStatus(date: Date = new Date()): CenterServiceAvailabilityStatus {
    const hours = date.getHours();

    if (hours < 5) {
        return CENTER_SERVICE_AVAILABILITY_STATUS.FULL_CENTER_BLOCKED;
    }

    if (hours >= 13) {
        return CENTER_SERVICE_AVAILABILITY_STATUS.SERVICE_RESERVATION_BLOCKED;
    }

    return CENTER_SERVICE_AVAILABILITY_STATUS.AVAILABLE;
}
